import React from "react";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import { ArrowRight } from "lucide-react";

function LoginFormV2({ handleSubmit, credentials, handleChange, loading, setShowForgotPassword, theme }) {
  return (
    <>
      {/* Header */}
      <div className="text-center mb-8">
        <div className="text-center mb-8 w-full h-[8dvh] p-3">
          <h2
            className="text-4xl font-semibold antialiased tracking-wider pt-4"
            style={{ color: theme && theme.mode === "light" ? theme.colors.primary_light : "#fff" }}
          >
            Bienvenido
          </h2>
          <p
            className="text-2xl font-normal antialiased tracking-normal pt-4"
            style={{ color: theme && theme.mode === "light" ? "#232323" : "#fff" }}
          >
            Ingresa tu información de usuario
          </p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col h-[30rem] justify-around m-4">
        <div className="space-y-6 pb-2">
          {/* Email Field */}
          <div>
            <label
              htmlFor="username"
              className="block text-2xl font-bold mb-2"
              style={{ color: theme && theme.mode === "light" ? "#232323" : "#fff" }}
            >
              Usuario
            </label>

            <div className="relative">
              <PersonIcon
                className="absolute left-3 top-1/2 -translate-y-1/2 size-11"
                sx={{ fontSize: 26, color: theme.mode === "light" ? theme.colors.primary_light : theme.colors.primary_light }}
              />

              <input
                type="text"
                id="username"
                name="username"
                value={credentials.username}
                onChange={handleChange}
                className="w-full text-2xl pl-16 pr-4 py-3 rounded-2xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                style={{
                  backgroundColor: theme && theme.mode === "light" ? "#E1E1E1" : "#fff",
                  color: theme && theme.mode === "light" ? "#232323" : "#232323",
                }}
                required
              />
            </div>
          </div>

          {/* Password Field */}
          <div>
            <label
              htmlFor="password"
              className="block text-2xl font-bold mb-2"
              style={{ color: theme && theme.mode === "light" ? "#232323" : "#fff" }}
            >
              Contraseña
            </label>
            <div className="relative">
              <LockIcon
                className="absolute left-4 top-1/2 -translate-y-1/2 size-11"
                sx={{ fontSize: 22, color: theme.mode === "light" ? theme.colors.primary_light : theme.colors.primary_light }}
              />

              <input
                type="password"
                id="password"
                name="password"
                value={credentials.password}
                onChange={handleChange}
                className="w-full text-2xl pl-16 pr-4 py-3 tablet:text-lg rounded-2xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                style={{
                  backgroundColor: theme && theme.mode === "light" ? "#E1E1E1" : "#fff",
                  color: theme && theme.mode === "light" ? "#232323" : "#232323",
                }}
                required
              />
            </div>
          </div>
        </div>

        {/* Grupo Inferior: Botones */}
        <div className="space-y-6 mb-3 flex flex-col justify-center items-center">
          {/* Sign In Button */}
          <button
            type="submit"
            disabled={loading}
            style={{
              backgroundColor: theme.mode === "light" ? theme.colors.primary_light : "#fff",
              color: theme.mode === "light" ? "#fff" : theme.colors.primary_light,
            }}
            className={`group w-[75%] text-[18px] font-semibold py-3 px-4 rounded-full transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 ${theme.mode === "light" ? "hover:shadow-[0px_6px_2px_0px_rgba(0,_0,_0,_0.1)]" : "hover:shadow-[0px_6px_2px_0px_rgba(255,_255,_255,_0.1)]"}`}
          >
            {loading ? "Iniciando sesión..." : "Ingresar"}

            {!loading && <ArrowRight />}
          </button>
          {/* Register Link */}
          {/* <div className="flex items-center justify-center gap-2 ">
          <p className="text-zinc-300 text-[12px] tablet:text-[14px]">¿No tienes una cuenta?</p>
          <a href="https://extranet.inatrans.cl/pre-inscription"
          type="button"
          className="text-[#44BCF9] hover:text-[#41Bad8] text-[15px] tablet:text-[18px] font-medium cursor-pointer transition-colors duration-200 hover:underline focus:outline-none focus:underline"
          >
          Regístrate aquí
          </a>
          </div> */}
          {/* Forgot Password */}
          <div className="text-center">
            <button
              type="button"
              onClick={() => setShowForgotPassword(true)}
              className="text-[15px] hover:opacity-85 transition-colors hover:underline"
              style={{color: theme.mode === "light" ? theme.colors.primary_light : "#fff",}}
            >
              Olvidaste tu contraseña?
            </button>
          </div>
        </div>
      </form>
    </>
  );
}

export default LoginFormV2;
